import { navigation } from './navigation'

export const staticData = {
    navigation
}